module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"complete":"Cancel completed."},"ja":{"complete":"キャンセルが完了しました。"}}')
  delete Component.options._Ctor
}
